module.exports = __webpack_public_path__ + "img/six_col.b75e1659.svg";